export const POSTHOG_DEFAULTS = "2026-01-30"

export const getPostHogHost = (): string =>
  import.meta.env.VITE_ENV === "prod"
    ? "https://t.aworld.cloud"
    : "https://t.aworld.services"
